var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1375 6.74375C5.0375 8.5125 6.4875 9.95625 8.25625 10.8625L9.63125 9.4875C9.8 9.31875 10.05 9.2625 10.2688 9.3375C10.9688 9.56875 11.725 9.69375 12.5 9.69375C12.8438 9.69375 13.125 9.975 13.125 10.3188V12.5C13.125 12.8438 12.8438 13.125 12.5 13.125C6.63125 13.125 1.875 8.36875 1.875 2.5C1.875 2.15625 2.15625 1.875 2.5 1.875H4.6875C5.03125 1.875 5.3125 2.15625 5.3125 2.5C5.3125 3.28125 5.4375 4.03125 5.66875 4.73125C5.7375 4.95 5.6875 5.19375 5.5125 5.36875L4.1375 6.74375Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalled);
export default __webpack_public_path__ + "static/media/called.7cf98623.svg";
export { ForwardRef as ReactComponent };